import { createAsyncThunk } from '@reduxjs/toolkit';
import { featuresClient } from 'api/clients';
import {
  fetchFeaturesSuccess,
  requestFailure,
  requestStart
} from './featuresSlice';

// Called once at login (App.js) — both SPAs' guard rules read from this slice.
export const fetchFeaturesThunk = createAsyncThunk(
  'features/fetchFeatures',
  async (_, { dispatch }) => {
    dispatch(requestStart());
    try {
      const features = await featuresClient.getFeatures();
      dispatch(fetchFeaturesSuccess(features));
    } catch (error) {
      dispatch(requestFailure(error.toString()));
    }
  }
);
